module.exports = __webpack_public_path__ + "img/alibb.b01610c8.png";